<template>
  <div>
    <p>
      <strong>Политика конфиденциальности&nbsp;{{ APP_NAME }}</strong>
    </p>
    <p>
      Получение доступа к Сайту или использование сервисов Сайта означает безоговорочное
      согласие Пользователя с настоящей Политикой и указанными в ней условиями обработки
      персональных данных.
    </p>
    <p>
      Политика разработана в соответствии с Федеральным законом от 27.07.2006 г. № 152-ФЗ
      &laquo;О персональных данных&raquo;, иными федеральными законами и нормативными
      правовыми актами Российской Федерации.
    </p>
    <p align="center">
      <strong>1. Определения</strong>
    </p>
    <p>1.1. В рамках настоящей Политики, термины и определения имеют следующее значение:</p>
    <p>
      <strong>Политика</strong>&nbsp;&ndash; настоящий документ&laquo;Политика
      конфиденциальности {{ APP_NAME }}&raquo;, являющийся неотъемлемой частьюПользовательского
      соглашения.
    </p>
    <p>
      <strong>Использование сервисов Сайта</strong>&nbsp;&ndash; регистрация/авторизация в
      Личном кабинете; направление анкеты Кандидата; прохождение собеседования; сохранение
      информации в Личном кабинете; приглашение на собеседование с помощью программного
      обеспечения Сайта; отправление сообщения в службу поддержки Сайта; использование форм
      обратной связи и иные действия Пользователя, связанные с возможностью получения
      Персональных данных Пользователя.&nbsp;Под использованием Сайта в целях настоящей
      Политики понимается также использование&nbsp;Расширения для браузера, принадлежащего
      Администрации Сайта.
    </p>
    <p>
      <strong>Расширение</strong>&nbsp;&ndash;&nbsp;совокупность программного
      обеспечения&nbsp;для браузера, содержащая модуль&nbsp;приглашения на&nbsp;Интервью,
      устанавливаемая путем внедрения специального программного кода на страницы внешнего
      сайта.
    </p>
    <p>
      <strong>Персональные данные</strong>&nbsp;&ndash; любая информация, относящаяся к прямо
      или косвенно определенному или определяемому лицу (субъекту Персональных данных).
    </p>
    <p>
      <strong>Технические данные</strong>&nbsp;&ndash; данные, которые автоматически
      передаются посредством установленного на устройстве Пользователя программного
      обеспечения, в том числе IP-адрес, информация из cookie, информация о браузере
      Пользователя, время доступа, адрес запрашиваемой страницы, версия операционной
      системы&nbsp;и иная подобная информация.
    </p>
    <p>
      <strong>Cookie</strong>&nbsp;&ndash; небольшой фрагмент данных,
      отправленный&nbsp;веб-сервером&nbsp;и хранимый на&nbsp;устройстве&nbsp;Пользователя,
      который веб-клиент всякий раз при попытке открыть страницу сайта пересылает веб-серверу
      в составе&nbsp;HTTP-запроса.
    </p>
    <p>
      <strong>IP-адрес</strong>&nbsp;&ndash; уникальный сетевой адрес узла в компьютерной
      сети, построенной по протоколу IP.
    </p>
    <p>
      <strong>Обработка Персональных данных</strong>&nbsp;&ndash;&nbsp;любые действия
      (операции) или совокупность действий (операций), совершаемых с&nbsp;использованием
      средств автоматизации или без использования таких средств с&nbsp;Персональными данными,
      включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление,
      изменение), извлечение, использование, передачу (распространение, предоставление,
      доступ), обезличивание, блокирование, удаление, уничтожение Персональных данных.
    </p>
    <p>
      <strong>Обезличивание Персональных данных</strong>&nbsp;&ndash; действия, в результате
      которых становится невозможным без использования дополнительной информации определить
      принадлежность Персональных данных конкретному субъекту Персональных данных.
    </p>
    <p>
      <strong>Распространение Персональных данных</strong>&nbsp;&ndash; действия, направленные
      на раскрытие Персональных данных неопределенному кругу лиц.
    </p>
    <p>
      <strong>Предоставление Персональных данных</strong>&nbsp;&ndash; действия, направленные
      на раскрытие Персональных данных определенному лицу или определенному кругу лиц.
    </p>
    <p>
      <strong>HR</strong>&ndash; Пользователь, использующий Сайт с целью поиска
      работников.&nbsp;HR&nbsp;является контрагентом Администрации Сайта в связи
      заключением&nbsp;договора оказания информационных услуг посредством присоединения
      к&nbsp;Правилам оказания услуг&nbsp;{{ APP_NAME }}.
    </p>
    <p>
      <strong>Кандидат&nbsp;</strong>&ndash; лицо, разместившее информацию о себе, включая
      контактную информацию, с целью поиска работы (трудоустройства либо выполнения
      работ/оказания услуг на ином законном основании) либо Пользователь, который проходит
      Интервью с помощью Сервисов Сайта.
    </p>
    <p>
      1.2. Термины, значение которых не раскрывается в настоящем разделе, имеют значение,
      приписанное им в Пользовательском соглашении.
    </p>
    <p align="center">
      <strong>2. Общие положения</strong>
    </p>
    <p>
      2.1. Политика разработана в соответствии с Федеральным законом от 27.07.2006 г. № 152-ФЗ
      &laquo;О персональных данных&raquo;, иными федеральными законами и нормативными
      правовыми актами Российской Федерации.
    </p>
    <p>
      2.2. Пользователь обязан полностью ознакомиться с Политикой до момента начала
      использования Сайта.
    </p>
    <p>
      2.3. Получение доступа к Сайту или использование сервисов Сайта означает безоговорочное
      согласие Пользователя с настоящей Политикой и указанными в ней условиями обработки
      Персональных данных.
    </p>
    <p>
      2.4. В случае если Пользователь не согласен с нормами, которые содержатся в настоящей
      Политике, он обязан прекратить использование Сайта. Любое использование Сайта
      Пользователем означает его полное согласие и принятие всех условий настоящей Политики.
    </p>
    <p>
      2.5. Администрация Сайта оставляет за собой право вносить изменения в текст настоящей
      Политики путем публикации новой редакции Политики на Сайте.
    </p>
    <p>
      2.6. Пользователь обязан регулярно отслеживать изменения, вносимые в Политику. Если
      Пользователь не согласен с новой редакцией Политики, то он обязан незамедлительно
      прекратить использование Сайта. В случае если после вступления в действие новой редакции
      Политики Пользователь продолжает использовать Сайт, то такой Пользователь тем самым
      подтверждает свое полное согласие с новой редакцией Политики.
    </p>
    <p>
      2.7. Настоящая Политика применяется только к сайту&nbsp;<a :href="`https://${HOME_DOMAIN}/`">https://{{ HOME_DOMAIN }}/</a>.
      Сайт может содержать ссылки на другие веб-сайты (vk.com, facebook.com, instagram.com,
      google.com и т.д.). Администрация Сайта не несет ответственность за политику обработки
      Персональных данных веб-сайтов третьих лиц, на которые Пользователь может перейти по
      ссылкам, доступным на страницах Сайта.
    </p>
    <p>
      2.8. Администрация Сайта не проверяет достоверность Персональных данных, предоставляемых
      Пользователем, кроме случаев, предусмотренных Пользовательским соглашением.
    </p>
    <p>
      2.9. Администрация Сайта не несет ответственности за сведения, добровольно
      распространенные Пользователем в общедоступной форме.
    </p>
    <p>
      2.10. Настоящим Пользователь гарантирует и подтверждает, что в случае предоставления
      Администрации Сайта персональных данных третьих лиц, Пользователь предоставляет
      персональные данные с их согласия либо такое согласие не требуется. В случае нарушения
      настоящей гарантии Пользователь возмещает Администрации Сайта все убытки, связанные с
      таким нарушением.
    </p>
    <p align="center">
      <strong>3. Состав Персональных данных</strong>
    </p>
    <p>
      3.1. Администрация Сайта осуществляет обработку только тех Персональных данных, которые
      необходимы для исполнения Пользовательского соглашения, заключения и исполнения иных
      договоров с Пользователем.
    </p>
    <p>
      3.2. Администрация Сайта вправе устанавливать требования к составу Персональной
      информации Пользователя, обязательно предоставляемой для использования сервисов Сайта.
      Если определенная информация не отмечена Администрацией Сайта как обязательная, ее
      предоставление или раскрытие осуществляется Пользователем на свое усмотрение.
    </p>
    <p>
      3.3. <strong>Состав персональных данных HR:</strong>
    </p>
    <p>3.3.1.&nbsp;Имя, фамилия, отчество;</p>
    <p>3.3.2.&nbsp;Адрес электронной почты;</p>
    <p>3.3.3.&nbsp;Номер телефона;</p>
    <p>3.3.4.&nbsp;Должность, место работы;</p>
    <p>3.3.5.&nbsp;Сведения о месте проживания.</p>
    <p>
      3.4. <strong>Состав персональных данных Кандидата:</strong>
    </p>
    <p>3.4.1.&nbsp;Имя, фамилия, отчество;</p>
    <p>3.4.2.&nbsp;Адрес электронной почты;</p>
    <p>3.4.3.&nbsp;Номер телефона;</p>
    <p>3.4.4.&nbsp;Пол;</p>
    <p>3.4.5.&nbsp;Дата рождения;</p>
    <p>3.4.6.&nbsp;Сведения о гражданстве и месте проживания;</p>
    <p>
      3.4.7.&nbsp;Сведения об образовании и профессиональной деятельности (место учебы,
      специальность, средний балл, год выпуска, места работы и должности);
    </p>
    <p>3.4.8.&nbsp;сведения о воинском учете;</p>
    <p>3.4.9.&nbsp;сведения о наличии/отсутствии водительского удостоверения.</p>
    <p>
      3.5. Персональные данные могут также включать в себя дополнительно предоставляемые
      Пользователем данные в целях исполнения Администрацией Сайта обязательств, вытекающих из
      Пользовательского соглашения, иных договоров с Пользователем. К таким данным могут
      относиться: ИНН; паспортные данные; сведения о семейном положении; видеозаписи, снятые
      во время собеседований; сведения, указанные в Личном кабинете; сведения, указанные в
      резюме. Администрация Сайта вправе запросить у Пользователя копию документа,
      удостоверяющегося личность Пользователя.
    </p>
    <p>
      3.6. Пользователь настоящим заявляет о своем согласии на обработку Администрацией Сайта
      Персональных данных Пользователя, в том числе, для целей, указанных в разделе 4
      настоящей Политики.
    </p>
    <p>
      3.7. Согласие Пользователя на обработку Персональных данных действует в
      течение&nbsp;10&nbsp;лет, но не менее срока, необходимого для целей обработки
      Персональных данных. Указанное Согласие может быть отозвано Пользователем в любой
      момент.
    </p>
    <p>
      3.8. Пользователь, желающий заблокировать или уточнить личную информацию, переданную
      Администрации Сайта, или прекратить ее обработку Администрацией Сайта, может обратиться
      к Администрации Сайта по E-mail, указанному в разделе 10. При этом Пользователь
      соглашается с тем, что Администрация Сайта не несет ответственности, если дальнейшей
      исполнение Пользовательского соглашения становится невозможным после уничтожения или
      блокирования Персональных данных.
    </p>
    <p>
      3.9. Реализованное право Пользователя, предусмотренное в&nbsp;п.3.8, не&nbsp;может
      являться причиной для прекращения обработки Персональных данных Пользователя при наличии
      оснований, предусмотренных Федеральным законом от&nbsp;27.07.2006&nbsp;г. №&nbsp;152-ФЗ
      &laquo;О&nbsp;персональных данных&raquo;.
    </p>
    <p align="center">
      <strong>4. Цели&nbsp;обработки</strong>
    </p>
    <p>
      4.1. Администрация Сайта обрабатывает Персональные данные Пользователя исключительно в
      целях исполнения Пользовательского соглашения, заключения и исполнения иных договоров с
      Пользователем.
    </p>
    <p>
      4.2. <strong>Цели обработки Персональных данных&nbsp;HR:</strong>
    </p>
    <p>
      4.2.1.&nbsp;предоставление Пользователю доступа к&nbsp;сервисам Сайта и его
      функциональным возможностям;
    </p>
    <p>4.2.2.&nbsp;определение Пользователя как стороны Пользовательского соглашения;</p>
    <p>
      4.2.3.&nbsp;связь с Пользователем, направление уведомлений и необходимой информации;
    </p>
    <p>
      4.2.4.&nbsp;предоставление эффективной клиентской и&nbsp;технической поддержки при
      возникновении проблем, связанных с&nbsp;использованием Cайта;
    </p>
    <p>
      4.2.5.&nbsp;рассылка информационных и рекламных сообщений о новостях, предложениях и
      акциях;
    </p>
    <p>
      4.2.6.&nbsp;подтверждение достоверности и&nbsp;полноты предоставленных Персональных
      данных;
    </p>
    <p>
      4.2.7.&nbsp;оказание содействия HR в предварительном отборе кандидатов для личного
      собеседования на вакансии компании;
    </p>
    <p>
      4.2.8.&nbsp;выполнение иных обязательств перед Пользователем в связи с исполнением
      Пользовательского соглашения и иных договоров.
    </p>
    <p>
      4.3. <strong>Цели обработки Персональных данных Кандидата:</strong>
    </p>
    <p>
      4.3.1.&nbsp;предоставление Пользователю доступа к&nbsp;сервисам Сайта и его
      функциональным возможностям;
    </p>
    <p>4.3.2.&nbsp;определение Пользователя как стороны Пользовательского соглашения;</p>
    <p>
      4.3.3.&nbsp;связь с Пользователем, направление уведомлений и необходимой информации;
    </p>
    <p>
      4.3.4.&nbsp;предоставление эффективной клиентской и&nbsp;технической поддержки при
      возникновении проблем, связанных с&nbsp;использованием&nbsp;Cайта;
    </p>
    <p>
      4.3.5.&nbsp;рассылка информационных и рекламных сообщений о новостях, предложениях и
      акциях;
    </p>
    <p>
      4.3.6.&nbsp;подтверждение достоверности и&nbsp;полноты предоставленных Персональных
      данных;
    </p>
    <p>
      4.3.7.&nbsp;оказание содействия Кандидату в поиске работы, прохождении собеседования;
    </p>
    <p>
      4.3.8.&nbsp;выполнение иных обязательств перед Пользователем в связи с исполнением
      Пользовательского соглашения и иных договоров.
    </p>
    <p>
      4.4. Пользуясь Сайтом, Пользователь в соответствии&nbsp;с Федеральным законом
      от&nbsp;13&nbsp;марта 2006&nbsp;г. N&nbsp;38-ФЗ &laquo;О&nbsp;рекламе&raquo;&nbsp;дает
      согласие на&nbsp;Email-рассылку сообщений рекламно-информационного характера на
      указанный им адрес электронной почты. Пользователь дает согласие на осуществление
      рекламно-информационной рассылки по SMS (в том числе, с использованием мессенджеров, а
      также с помощью сервисов рассылки) на указанный им номер телефона.
    </p>
    <p>
      4.5. Согласие на получение рассылок является добровольным, и Пользователь может в любое
      время отказаться от дальнейшего получения новостей и информации.&nbsp;Отписаться от
      рассылки можно по ссылке, указанной в письме, либо, направив соответствующее обращение
      Администрации Сайта по адресу или E-mail, указанным в разделе 10.
    </p>
    <p align="center">
      <strong>5. Условия обработки Персональных данных</strong>
    </p>
    <p>
      5.1. Администрация Сайта собирает и хранит Персональные данные Пользователя в
      соответствии с внутренними регламентами.
    </p>
    <p>
      5.2. Обработка Персональных данных Пользователя осуществляется в
      течение&nbsp;10&nbsp;лет (но с учетом времени, необходимого для целей обработки
      Персональных данных).
    </p>
    <p>
      5.3. Администрация Сайта обязуется не распространять Персональные данные Пользователя.
    </p>
    <p>
      5.4. Администрация Сайта не предоставляет Персональные данные третьим лицам, за
      исключением перечисленных случаев:
    </p>
    <p>
      5.5. Пользователь дал на это свое согласие (в том числе, если Пользователь принял
      условия Пользовательского соглашения), включая случаи применения Пользователем настроек
      используемого программного обеспечения&nbsp;(в т.ч. при использовании Расширения), не
      ограничивающих предоставление определенной информации&nbsp;(например, Персональные
      данные Кандидата в этом случае могут быть предоставлены&nbsp;HR);
    </p>
    <p>
      5.5.1.&nbsp;Если получение, использование и раскрытие такой информации необходимо с
      целью выполнения судебных решений или исполнения законных требований государственных
      органов;
    </p>
    <p>В других случаях, предусмотренных действующим законодательством.</p>
    <p>5.5.2.&nbsp;</p>
    <p>
      5.6. Администрация Сайта принимает необходимые и достаточные организационные и
      технические меры для защиты Персональных данных Пользователя от несанкционированного или
      случайного доступа, в том числе несанкционированного уничтожения, изменения,
      блокирования, копирования, распространения, а также от иных видов ненадлежащего
      использования.
    </p>
    <p>
      5.7. В частности, Администрацией Сайта постоянно совершенствуются способы сбора,
      хранения и обработки данных, включая физические меры безопасности. Администрация Сайта
      предоставляет доступ к Персональным данным только тем сотрудникам, которым эта
      информация необходима для выполнения обязанностей перед Пользователем. Такие лица
      связаны с Администрацией Сайта строгими обязательствами по соблюдению
      конфиденциальности, за нарушение которых могут быть привлечены к ответственности.
    </p>
    <p align="center">
      <strong>6. Специальные категории персональных данных</strong>
    </p>
    <p>
      6.1. По общему правилу Администрация Сайта не осуществляет обработку специальных
      категорий персональных данных, биометрических персональных данных.
    </p>
    <p>
      6.2. Обработка Операторами специальных категорий персональных данных, касающихся
      расовой, национальной принадлежности, политических взглядов, религиозных или философских
      убеждений, состояния здоровья, интимной жизни, допускается в случаях, если: субъект
      персональных данных дал согласие в письменной форме на обработку своих персональных
      данных;&nbsp;в иных случаях, предусмотренных законодательством РФ.
    </p>
    <p>
      6.3. Сведения, которые характеризуют физиологические и биологические особенности
      человека, на основании которых можно установить его личность&nbsp;(биометрические
      персональные данные),&nbsp;могут обрабатываться&nbsp;Администрацией Сайта&nbsp;только
      при наличии согласия субъекта персональных данных в письменной форме.
    </p>
    <p />
    <p align="center">
      <strong>7. Обработка Технических данных</strong>
    </p>
    <p>
      7.1. Администрация Сайта может собирать обезличенную информацию, не касающуюся конкретно
      Пользователя, но предоставленную им, для предоставления Пользователю персонализированных
      сервисов и для улучшения работы Сайта.
    </p>
    <p>
      7.2. Во время посещения Сайта собирается техническая и статистическая информация из
      стандартных журналов регистрации сервера (server logs). Администрация Сайта получает
      доступ к следующим данным: IP-адрес устройства Пользователя (либо прокси-сервера, если
      он используется), наименование Интернет-провайдера, имя домена, тип браузера и
      операционной системы, информация о сайте, с которого Пользователь совершил переход на
      Сайт, о посещенных страницах Сайта, дате и времени этих посещений.
    </p>
    <p>
      7.3. Файлы cookies, а также иные технологии, такие как веб-маяки (web&nbsp;beacons),
      могут использоваться Администрацией Сайта.&nbsp;При этом Администрация Сайта не
      сохраняет Персональные данные или пароли в файлах cookies. Пользователь понимает, что
      оборудование и программное обеспечение, используемые им для посещения сайтов в сети
      Интернет, могут обладать функцией запрещения операций с файлами cookies, а также
      удаления ранее полученных файлов cookies.&nbsp;Следует учесть, что некоторые функции
      Сайта могут стать недоступными после отключения cookies.
    </p>
    <p>
      7.4. Пользователь понимает и соглашается с тем, что на Сайте может использоваться
      программного обеспечение третьих лиц, в результате чего такие лица могут получать
      обезличенные данные. К такому программному обеспечению третьих лиц могут относиться:
      плагины социальных сетей; системы показов баннеров; системы по сбору статистики
      посещений и другие системы сбора обезличенной информации. Пользователь среди прочего
      соглашается с тем, Администрация Сайта может передавать Обществу с ограниченной
      ответственностью &laquo;Яндекс&raquo; и компании Google Inc информацию об использовании
      Пользователем Сайта при помощи таких счетчиков, как Яндекс.Метрика, Google.Analytics.
      Технические параметры работы счетчиков могут изменяться без уведомления Пользователя.
    </p>
    <p>
      7.5. Пользователь настоящим уведомлен о наличии на Сайте
      проверки&nbsp;reCAPTCHA&nbsp;v3, а также о необходимости соблюдать
      <a href="https://www.google.com/policies/privacy/">Политику конфиденциальности</a>
      и <a href="https://www.google.com/policies/terms/">Условия использования&nbsp;Google</a>.
      Система&nbsp;reCAPTCHA&nbsp;v3 применяется только для борьбы со спамом и другими
      нарушениями. Система не используется в других целях, например для определения
      кредитоспособности, работоспособности, финансового статуса или страховых возможностей.
    </p>
    <p align="center">
      <strong>8. Ответственность Сторон и разрешение споров</strong>
    </p>
    <p>
      8.1. Администрация Сайта не несет ответственности, еслиПерсональные данные были
      разглашены с разрешения Пользователя, либо данные Пользователя были предоставлены
      Администрации Сайта третьими лицами.
    </p>
    <p>8.2. Досудебный порядок урегулирования споров является обязательным.</p>
    <p>
      8.3. Срок рассмотрения претензионного письма составляет 30 дней со дня получения, если
      более короткий срок не предусмотрен законодательством.
    </p>
    <p>8.4. Все споры подлежат рассмотрению в суде по месту нахождения ответчика.</p>
    <p />
    <p align="center">
      <strong>9. &nbsp;Заключительные&nbsp;положения</strong>
    </p>
    <p>
      9.1. Настоящая Политика регулируется и толкуется в соответствии с законодательством
      Российской Федерации. В случае если одно или несколько положений Политики утратят свою
      силу или окажутся недействительными, или не имеющими юридической силы, это не оказывает
      влияния на действительность или применимость остальных положений Политики.
    </p>
    <p>
      9.2. Обращения, предложения и претензии к Администрации Сайта в связи с нарушениями прав
      и интересов Пользователя или третьих лиц, а также отзыв согласия на обработку
      Персональных данных, могут быть направлены по реквизитам, указанным в разделе 10, в том
      числе, по адресу электронной почты.
    </p>
    <p />
    <p align="center">
      <strong>10. Реквизиты Администрации Сайта</strong>
    </p>
    <p>
      ООО "Бозон"
    </p>
    <p>
      ОГРН: 1187746716563
    </p>
    <p>
      105066, г. Москва, вн.тер.г. Муниципальный Округ
      <br>
      Басманный, ул Доброслободская, д. 7/1 стр. 3, помещ. 3/2
    </p>
    <p>Еmail: <a :href="`mailto:${SUPPORT_EMAIL}`">{{ SUPPORT_EMAIL }}</a></p>
  </div>
</template>

<script>
import { HOME_DOMAIN, APP_NAME, SUPPORT_EMAIL } from '@/helpers/constants';

export default {
  name: 'Confidential',
  data() {
    return {
      HOME_DOMAIN,
      APP_NAME,
      SUPPORT_EMAIL,
      pageTitle: `Политика конфиденциальности ${APP_NAME}`,
    };
  },
  metaInfo() {
    return {
      title: this.pageTitle,
    };
  },
  mounted() {
    this.$nextTick(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  },
};
</script>
